var $ = require('jquery');
require('slick-carousel');

// default
$('.dd-facts__content__item--1').addClass('is-active');
$('.dd-facts__tabs__item--1').addClass('is-active');

$('.dd-facts__content__item').each(function () {
  let $fact = $(this);
  var $items = $fact.find('.dd_product__spec__item');
  if ($items.length >= 8) {
    $fact.addClass('is-expendable');
    $fact.on('click', function (event) {
      console.log('yo')
      $fact.toggleClass('is-shown');
    });
  }
});

// Navigation
$('.dd-facts__tabs__item').each(function () {
  let $self = $(this);




  $self.on('click', function (event) {
    let $id = $(this).attr("data-tab");

    // Marker active
    $('.dd-facts__tabs__item').removeClass('is-active');
    $('.dd-facts__tabs__item--' + $id).addClass('is-active');

    // Content Active
    $('.dd-facts__content__item').removeClass('is-active');
    $('.dd-facts__content__item--' + $id).addClass('is-active');

  });

});





